import { createApp } from 'vue';
import App from './App.vue';
import './style.css';
import { applyThemeParams, initMaxBridge } from './max-bridge';

// Поднять MAX Bridge до того, как Vue смонтируется.
// Если открыли вне MAX (dev в обычном браузере) — продолжаем работать с моками.
initMaxBridge();
applyThemeParams();

createApp(App).mount('#app');

// TASK-006: регистрация PWA service worker + авто-обновление.
//
// Когда мы пушим новую версию (deploy-beget.py), SW сам видит новый sw.js,
// инсталлируется в фоне и сразу skipWaiting'ом активируется. На клиенте
// мы слушаем 'controllerchange' → перезагружаем страницу с новым shell.
//
// Это даёт «обновление сразу как только версия выходит в коммит и пуш».
if ('serviceWorker' in navigator && location.protocol.startsWith('http')) {
  let refreshing = false;
  // Перезагрузка когда новый SW взял control над клиентом
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    console.info('[sw] controller changed → reload');
    window.location.reload();
  });
  // Дополнительный сигнал от SW (см. self.clients.matchAll → postMessage)
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'sw-updated') {
      console.info('[sw] new version', event.data.version);
    }
  });
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((reg) => {
        console.info('[sw] registered scope=', reg.scope);
        // Принудительный пинг проверки апдейта каждые 60 минут, если PWA открыто долго
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
        // И сразу — на случай если пользователь только что открыл после нашего пуша
        reg.update().catch(() => {});
      })
      .catch((err) => {
        console.warn('[sw] register failed', err);
      });
  });
}
